import { withLazyFallback } from 'lib/hoc/withLazyFallback';

const Tasks = withLazyFallback(() => import('components/admin/pages/Tasks/Tasks'));
const AdminEditTaskModal = withLazyFallback(
  () => import('components/admin/pages/Tasks/components/AdminEditTaskModal')
);

const ADMIN_TASKS = [
  {
    path: 'tasks',
    element: <Tasks />,
    handle: { title: 'Tasks' },
    children: [
      {
        path: ':id',
        element: <AdminEditTaskModal />,
        handle: { title: 'Task' }
      }
    ]
  }
];

export default ADMIN_TASKS;
